export default function ChatgptFirstDraft() {
  return <h2>Chatgpt First Draft</h2>;
}
